import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  pipeline: "Pipeline",
  pipelineDescription: "Open flows now · completed in the period",
  draft: "Draft",
  inProgress: "In progress",
  inReview: "In review",
  signing: "Signing",
  completed: "Completed",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    pipeline: "Pipeline",
    pipelineDescription: "Parcours ouverts actuellement · terminés sur la période",
    draft: "Brouillon",
    inProgress: "En cours",
    inReview: "En revue",
    signing: "Signature",
    completed: "Terminé",
  },
  es_ES: {
    pipeline: "Pipeline",
    pipelineDescription: "Flujos abiertos ahora · completados en el periodo",
    draft: "Borrador",
    inProgress: "En curso",
    inReview: "En revisión",
    signing: "En firma",
    completed: "Completado",
  },
  pt_BR: {
    pipeline: "Pipeline",
    pipelineDescription: "Fluxos abertos agora · concluídos no período",
    draft: "Rascunho",
    inProgress: "Em andamento",
    inReview: "Em revisão",
    signing: "Em assinatura",
    completed: "Concluído",
  },
  de_DE: {
    pipeline: "Pipeline",
    pipelineDescription: "Aktuell offene Flows · im Zeitraum abgeschlossen",
    draft: "Entwurf",
    inProgress: "In Bearbeitung",
    inReview: "In Prüfung",
    signing: "Zur Signatur",
    completed: "Abgeschlossen",
  },
  it_IT: {
    pipeline: "Pipeline",
    pipelineDescription: "Flussi aperti ora · completati nel periodo",
    draft: "Bozza",
    inProgress: "In corso",
    inReview: "In revisione",
    signing: "In firma",
    completed: "Completato",
  },
  ar: {
    pipeline: "خط سير العمل",
    pipelineDescription: "المسارات المفتوحة حاليًا · المكتملة خلال الفترة",
    draft: "مسودة",
    inProgress: "قيد التنفيذ",
    inReview: "قيد المراجعة",
    signing: "قيد التوقيع",
    completed: "مكتمل",
  },
  ja_JP: {
    pipeline: "パイプライン",
    pipelineDescription: "現在進行中のフロー · 期間内の完了",
    draft: "下書き",
    inProgress: "進行中",
    inReview: "レビュー中",
    signing: "署名中",
    completed: "完了",
  },
  hi_IN: {
    pipeline: "पाइपलाइन",
    pipelineDescription: "अभी खुले फ़्लो · अवधि में पूर्ण",
    draft: "ड्राफ़्ट",
    inProgress: "प्रगति में",
    inReview: "समीक्षा में",
    signing: "हस्ताक्षर जारी",
    completed: "पूर्ण",
  },
  zh_CN: {
    pipeline: "流程管道",
    pipelineDescription: "当前进行中的流程 · 期间内已完成",
    draft: "草稿",
    inProgress: "进行中",
    inReview: "审核中",
    signing: "签署中",
    completed: "已完成",
  },
  zh_TW: {
    pipeline: "流程進度",
    pipelineDescription: "目前進行中的流程 · 期間內已完成",
    draft: "草稿",
    inProgress: "進行中",
    inReview: "審核中",
    signing: "簽署中",
    completed: "已完成",
  },
  nl_NL: {
    pipeline: "Pipeline",
    pipelineDescription: "Open flows nu · voltooid in de periode",
    draft: "Concept",
    inProgress: "Bezig",
    inReview: "In beoordeling",
    signing: "Ondertekening",
    completed: "Voltooid",
  },
  nb_NO: {
    pipeline: "Pipeline",
    pipelineDescription: "Åpne flyter nå · fullført i perioden",
    draft: "Utkast",
    inProgress: "Pågår",
    inReview: "Til gjennomgang",
    signing: "Signering",
    completed: "Fullført",
  },
  sv_SE: {
    pipeline: "Pipeline",
    pipelineDescription: "Öppna flöden nu · slutförda under perioden",
    draft: "Utkast",
    inProgress: "Pågår",
    inReview: "Under granskning",
    signing: "Signering",
    completed: "Slutförd",
  },
  fi_FI: {
    pipeline: "Putki",
    pipelineDescription: "Avoimet prosessit nyt · valmistuneet jakson aikana",
    draft: "Luonnos",
    inProgress: "Käynnissä",
    inReview: "Tarkastettavana",
    signing: "Allekirjoitus",
    completed: "Valmis",
  },
  da_DK: {
    pipeline: "Pipeline",
    pipelineDescription: "Åbne forløb nu · gennemført i perioden",
    draft: "Kladde",
    inProgress: "I gang",
    inReview: "Til gennemgang",
    signing: "Underskrivelse",
    completed: "Gennemført",
  },
  is_IS: {
    pipeline: "Verkflæði",
    pipelineDescription: "Opin ferli núna · lokið á tímabilinu",
    draft: "Drög",
    inProgress: "Í vinnslu",
    inReview: "Í yfirferð",
    signing: "Undirritun",
    completed: "Lokið",
  },
};
